import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractSecondaryToolbar } from '../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { ToggleButton } from '../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { customIcon } from '../../../cross-team-shared/icons/register-custom-icons';
import { isOrthographicVideoOutput } from '../../../cross-team-shared/misc-utils/output-utils';
import { MeasureToolMode } from '../../../cross-team-shared/types/tool-modes';
import { PointCloudContentState } from '../../state/point-cloud-content-state';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import {
  distanceFreePoint,
  distanceGroundToPoint,
} from '../../utils/custom-icons';
import { MeasureTool } from './measure-tool';

const freePointButton: ToggleButton<MeasureToolMode> = {
  value: 'free-point',
  icon: customIcon(distanceFreePoint),
  tooltip: 'Free point mode: measure between two ground points',
};

const subpointHeightButton: ToggleButton<MeasureToolMode> = {
  value: 'subpoint-height',
  icon: customIcon(distanceGroundToPoint),
  tooltip: 'Subpoint mode: measure the height distance from a subpoint',
};

@Component({
  selector: 'h3-measure-secondary-bar',
  templateUrl: './measure-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MeasureSecondaryToolbar3DComponent extends AbstractSecondaryToolbar<
  PointCloudContentState,
  PointCloudContentStore,
  MeasureTool
> {
  buttons = this.buildButtons();

  private buildButtons() {
    const buttons = [freePointButton];

    if (
      inject(PointCloudContentStore)
        .state()
        .project.outputs.find(isOrthographicVideoOutput)
    ) {
      buttons.push(subpointHeightButton);
    }

    return buttons;
  }
}
